export const ROOT = '/'
export const STRONGHOLD = '/stronghold'
export const FOREIGN_STRONGHOLD = (clanId) => `/stronghold/${clanId}`
export const BUILDING = (buildingId) => `/stronghold/building/${buildingId}`
export const BUILD = (slotId) => `/build/${slotId}`
export const BATTLEROOMS = '/battlerooms'
export const UNITS_CREATE = '/units/create'
export const UNITS_REBUILD = (unitServerId) => `/units/rebuild/${unitServerId}`
export const JOURNAL = '/stronghold/journal'
export const CHALLENGES = '/challenges'
export const CLAN_MANAGEMENT = '/clan_management'
export const CLAN_LEAVING = '/clan_management/leaving'
export const STUB = '/stub'
export const LOG = '/stronghold/log'
export const LEADERBOARD = '/stronghold/leaderboard'
export const FORT_BATTLE_RESULTS = (seriesId, clanId) => `/postbattle/${seriesId}/${clanId}`
export const CLAN_LANDING = '/clanLanding'
export const WGCWX_SHOP = '/personal_shop/products'
export const WGCWX_SHOP_REWARDS = '/personal_shop/rewards'
export const WGCWX_BATTLE_SCHEDULE = '/battle_schedule'
export const WGCWX_LEADERBOARDS = '/leaderboards'
export const SHOP_STOREFRONT = '/shop/storefront'
export const SHOP_PRODUCT_PREVIEW = (productId = ':productId') => `/shop/preview/${productId}`
export const SHOP_ERROR = (errorId = ':id') => `/shop/error/${errorId}`
export const SHOP_CONGRATULATIONS = (productId = ':productId') => `/shop/congratulations/${productId}`
export const SHOP_STUB = (stubId = ':id') => `/shop/stub/${stubId}`



// WEBPACK FOOTER //
// ./urls.js